import { createFileRoute, redirect } from '@tanstack/react-router'
import { Main } from '@/components/layout'
import { FlowAdmin } from '@/features/flow-admin'
import { useAuthStore } from '@/stores/auth-store'
import { ROLE } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/flow-admin/')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()

    if (!auth.user || auth.user.role < ROLE.ADMIN) {
      throw redirect({
        to: '/403',
      })
    }
  },
  component: FlowAdminPage,
})

function FlowAdminPage() {
  return (
    <Main className='p-0'>
      <FlowAdmin />
    </Main>
  )
}
